import { useEffect, useState, useCallback } from "react";
import { Coupon, useCouponSmart } from "@/hooks/useCoupons";

export const useCouponManager = (
  code: string,
  applyCoupon: (c: Coupon) => void
) => {
  const [codeToVerify, setCodeToVerify] = useState("");
  const [popup, setPopup] = useState<{
    type: "success" | "error";
    message: string;
    icon: string;
  } | null>(null);

  const {
    data: couponData,
    isSuccess: couponSuccess,
    isError: couponError,
    isLoading: couponLoading,
  } = useCouponSmart(codeToVerify);

  const handleVerify = useCallback(() => {
    if (!code.trim()) {
      setPopup({
        type: "error",
        message: "يرجى إدخال كود الخصم أولاً",
        icon: "/icons/error.svg",
      });
      return;
    }
    setCodeToVerify(code.trim());
  }, [code]);

  useEffect(() => {
    if (!codeToVerify || couponLoading) return;

    const matched = couponData;
    // const isTestMode = process.env.NODE_ENV === "development";

    if (!couponSuccess || !matched || couponError) {
      setPopup({
        type: "error",
        message: `الكود "${codeToVerify}" غير موجود في النظام`,
        icon: "/icons/error.svg",
      });
    } else if (!matched.is_active) {
      setPopup({
        type: "error",
        message: `الكوبون "${matched.code}" غير نشط حالياً`,
        icon: "/icons/error.svg",
      });
    } else if (!matched.is_available) {
      setPopup({
        type: "error",
        message: `الكوبون "${matched.code}" غير متوفر للاستخدام`,
        icon: "/icons/error.svg",
      });
    } else {
      applyCoupon(matched);
      setPopup({
        type: "success",
        message: `تم تطبيق كوبون "${matched.code}" بنجاح! خصم ${matched.discount_percentage}%`,
        icon: "/icons/success.svg",
      });
    }

    setCodeToVerify("");
  }, [
    codeToVerify,
    couponData,
    couponSuccess,
    couponError,
    couponLoading,
    applyCoupon,
  ]);

  return {
    popup,
    setPopup,
    handleVerify,
    couponLoading,
  };
};
